import "./footerstyles.css";

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="obj-width">
          <div className="top">
            <div>
              <h1>ARCITY</h1>
              <p>Your Gateway to Discovery.</p>
            </div>
            <div>
              <a href="https://www.facebook.com/arcityofficial" target="_blank" rel="noopener noreferrer">
                <i  className="fa-brands fa-facebook-square"></i>
              </a>
              <a href="https://www.instagram.com/arcityofficial/" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-instagram-square"></i>
              </a>
              <a href="https://www.youtube.com/@ARCity-n2n" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-youtube-square"></i>
              </a>
              {/* <a href="/">
                <i className="fa-brands fa-twitter-square"></i>
              </a> */}
            </div>
          </div>

          <div className="bottom">
            <div>
              <h4>Explore</h4>
              <a href="/"className="disabled-link">Destinations</a>
              <a href="/"className="disabled-link">Travel Guides</a>
              <a href="/service">Tour Packages</a>
              <a href="/"className="disabled-link">Local Guides</a>
            </div>
            <div>
              <h4>Community</h4>
              <a href="/"className="disabled-link">Travel Blog</a>
              <a href="/"className="disabled-link">Travel Stories</a>
              <a href="/"className="disabled-link"> Photo Gallery</a>
            </div>
            <div>
              <h4>Help</h4>
              {/* <a href="/contact">Support</a> */}
              <a href="/Troubleshoot">Troubleshooting</a>
              <a href="/contact">Contact Us</a>
            </div>
            <div>
              <h4>Others</h4>
              <a href="/terms_of_service">Terms of Service</a>
              <a href="/pri_policy">Privacy Policy</a>
              <a href="/cookie_policy">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
